import { render, staticRenderFns } from "./baseInfoVoice.vue?vue&type=template&id=57030bba&scoped=true"
import script from "./baseInfoVoice.vue?vue&type=script&lang=js"
export * from "./baseInfoVoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57030bba",
  null
  
)

export default component.exports